import { styled } from "../../../../styled-components";

export const SignatureViewStyle = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    padding: 30px 30px 30px 30px;
    flex-grow: 1;

    display: flex;
    flex-direction: column;
    justify-content: center;

    .underline-container {
        display: flex;
        align-items: center;
        width: 100%;

        .underline {
            width: 100%;
            margin-left: 4px;
            background-color: ${p => p.theme.fgColorLight};
            height: 1px;
        }
    }

    .description {
        margin-top: 4px;
        text-align: center;
        color: ${p => p.theme.fgColorLight};
    }

    .signature-canvas {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .canvas-style-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .canvas-style-container.invert {
        filter: invert(1);
    }
`;
